export class AddressModel {
  constructor(
    public FirstName: string = '',
    public LastName: string = '',
    public StreetAddress: string = '',
    public AdditionalAddress: string = '',
    public City: string = '',
    public Country: string = '',
    public SelectedCountry: string = '',
    public BillingCountryList_ForAPI: CountryModel[] = [],
    public State: string = '',
    public SelectedState: string = '',
    public BillingUSAStateList_ForAPI: CountryModel[] = [],
    public BillingCanadaStateList_ForAPI: CountryModel[] = [],
    public ZipCode: string = '',
    public Phone: string = '',
    public Ext: Number = null,
    public BillingShippingDifferent: boolean = false,
    public ShippingFirstName: string = '',
    public ShippingLastName: string = '',
    public ShippingStreetAddress: string = '',
    public ShippingAdditionalAddress: string = '',
    public ShippingCity: string = '',
    public ShippingCountry: string = '',
    public BillingCountryCode: string = '',
    public ShippingCountryCode: string = '',
    public SelectedShippingCountry: string = '',
    public ShippingState: string = '',
    public SelectedShippingState: string = '',
    public ShippingZipCode: string = '',
    public ShippingPhone: string = '',
    public ShippingUSAStateList_ForAPI: CountryModel[] = [],
    public ShippingCanadaStateList_ForAPI: CountryModel[] = [],
    public ShippingExt: Number = null,
    public RequiresShipping: boolean = false,
    public IsShoppingCart: boolean = true
  ) { }
}

export class CountryModel {
  constructor(
    public Selected: boolean = false,
    public Text: string = null,
    public Value: string = null
  ) { }
}
export class PaymentModel {
  constructor(
    public Name: string = '',
    public CreditCardNumber: string = '',
    public SecurityCode: string = '',
    public ExpirationDateMonth: string = '',
    public ExpirationDateYear: string = '',
    public SelectedExpirationDateMonth: MonthOrYearModel = new MonthOrYearModel(),
    public SelectedExpirationDateYear: MonthOrYearModel = new MonthOrYearModel(),
    public ExpirationDateYearList_ForAPI: MonthOrYearModel[] = [],
    public ExpirationDateMonthList_ForAPI: MonthOrYearModel[] = []
  ) { }

}
export class MonthOrYearModel {
  constructor(
    public Selected: boolean = false,
    public Text: string = '',
    public Value: string = '',
    public Disabled: boolean = false,

  ) { }
}
export class CartItemsModel {
  constructor(
    public ImageUrl: string = '',
    public RemoveImageUrl: string = '',
    public WebTitle: string = '',
    public ProductID: number = 0,
    public ISBN13: string = '',
    public ListPrice: number = 0,
    public strListPrice: string = '',
    public DoShowDiscount: boolean = false,
    public DiscountPercent: string = '',
    public NetPrice: number = 0,
    public strNetPrice: string = '',
    public IsDigitalProduct: boolean = false,
    public Quantity: number = 0,
    public OrderSubTotal: number = 0,
    public strOrderSubTotal: string = '',
    public AppId: number = 0,
    public FulfillmentClass: string = '',
    public CanCartCheckout: boolean = false,
    public PromoCodeMessage: string = '',
    public ProductTypeFormat: string = '',
    public CartSubtotal: string = '',
    public FullISBN13: string = '',
    public Selected: boolean = false,
    public TaxAmount: number = 0,
    public PromoCodeAmount: number = 0,
    public PromoCode: string = '',
    public ShippingMessage: string = '',
    public ShippingCharge: number = 0, 
    public RedirectProductURL: string = '',
    public IsStockAvailable: boolean = true//LMM-5209 changes
  ) { }
}

export class UserModel {
  constructor(
    public UserName: string = null,
    public Password: string = null,
    public AppID: string = null,
    public ApplicationID: string = null,
    // public ForgotEmail: string = null,
    public Key: number = null,
    public AccountID: number = null,
    public FirstName: string = null,
    public LastName: string = null,
    public Email: string = null,
    public IsActive: boolean = null,
    public IsConfirmed: boolean = null,
    public CreatedDate: string = null,
    public Role: string = null,
    public token: string = null,
    public status: string = null,
    public tokenFromUser: string = null
  ) { }
}

export class ShoppingCartModel {
  constructor(
    public ProductID: number = 0,
    public AccountID: number = 0,
    public PromoCode: string = '',
    public ShoppingCartGUID: string = '',
    public Quantity: number = 0,
    public ShoppingCartID: number = 0,
    public ProductIDs: string = ''
  ) { }
}
export class ErrorResponse {
  constructor(
    public ErrorResponseBody: ErrorBody = new ErrorBody(),
    public status: string = '',
    public statusText: string = ''
  ) { }
}
export class ErrorBody {
  constructor(
    public Error: string = '',
    public Message: string = '',
    public Data: string = ''
  ) { }
}

export class ApplicationListModel {
  constructor(
    public AppID: number = null,
    public AppName: string = null,
    public AppURL: string = null,
    public IsActive: boolean = null,
    public AppBarSort: number = null,
    public AppBarFixedPosition: boolean = null,
    public IsEnabled: boolean = null
  ) { }
}

export class UpsellItemsModel {
  constructor(
    public Sortorder: number = null,
    public Productid: number = null,
    public Title: string = null,
    public Price: number = null,
    public DisplayISBN: string = null,
    public URL: string = null,
    public ImageUrl: string = null
  ) { }
}

export class UspsAddressModel {
  public Address1: string;
  public Address2: string;
  public City: string;
  public State: string;
  public Zip5: string;
  public ReturnText: string;
}






// WEBPACK FOOTER //
// ./src/app/core/models/ShoppingCart.model.ts